import * as React from 'react';
import { IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react';
import { FiPlay, FiPause } from 'react-icons/fi';
import { userHasRequiredPermissions } from 'hooks';
import { CAN_EDIT_PRODUCTS } from 'consts/permissions';
import { useTranslation } from 'react-i18next';

export type ToggleStatusIconButtonProps = {
  onToggle: () => void;
  entityName: string;
  isActive: boolean;
  isLoading?: boolean;
};

export const ToggleStatusIconButton = ({
  entityName,
  isActive,
  isLoading,
  onToggle,
  ...props
}: ToggleStatusIconButtonProps & IconButtonProps): JSX.Element | null => {
  const { t } = useTranslation();
  const userHasPermissions = userHasRequiredPermissions([CAN_EDIT_PRODUCTS]);

  if (!userHasPermissions) return null;

  const label = t('setEntityNameAsVal', 'Ustaw {{entityName}} jako {{val}}', {
    entityName,
    val: isActive ? 'nieaktywny' : 'aktywny',
  });

  return (
    <Tooltip label={label} placement='top' hasArrow>
      <IconButton
        icon={isActive ? <FiPause /> : <FiPlay />}
        isLoading={isLoading}
        onClick={onToggle}
        {...props}
        aria-label={label}
      />
    </Tooltip>
  );
};
